module.exports = __webpack_public_path__ + "img/code-text.82bb3643.png";